import {ListActionProvider as SuperOrderListProvider} from "@beeldit/ecommerce/super-orders/actions/list/ListActionContext";
import SuperOrdersPage from "@beeldit/ecommerce/super-orders/pages/SuperOrdersPage";
import CustomersRouterWrapper from "@main/customers/wrappers/CustomersRouterWrapper";

function DashboardPage(props: any) {
  return (
    <div className="dashboard-page row">
      {/*
        //* TODO
        Se están cargando los mismos componentes que en Pedidos y Distribuidores.
        Esta vista es para ver un resumen de los últimos pedidos y distribuidores.
        No es necesario cargar todas las columnas, acciones ni los filtros.
        Cargar solo una lista id, cliente, fecha, total, estado para pedidos
        y solo id, nombre y email para distribuidores.
      */}

      <div className="col-md-6 mb-5">
        <SuperOrderListProvider>
          <SuperOrdersPage
            filters={{}}
          />
        </SuperOrderListProvider>
      </div>

      <div className="col-md-6 mb-5">
        <CustomersRouterWrapper
          key={'dealers'}
          title={'dealers'}
          filters={{ role: 'dealer', status: 0}}
          formDefaultValues={{ user: { role: 'dealer'}, create_address: true}}
        />
      </div>
    </div>
  );
}

export default DashboardPage;
